import React, { useState } from "react";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import SuperAdminSidebar from "./Components/SuperAdminSidebar";
import threeHorizontalDots_icon from "../../assets/icons/threeHorizontalDots_icon.png";
import users_icon_02 from "../../assets/icons/users_icon_02.png";
import comments_icon from "../../assets/icons/comments_icon.png";
import files_icon from "../../assets/icons/files_icon.png";
import appDetails_graph from "../../assets/images/appDetails_graph.png";
import westside_image from "../../assets/images/westside_image.png";
import SuperAdminSearchBar from "./Components/SuperAdminSearchBar";

const SuperAdminDashboard = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SuperAdminSearchBar categoryName="Dashboard" route="/super-admin" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <SuperAdminSidebar />}
        </div>
      </div>
      {/* 1 */}
      <div className="ml-4 mt-10 bg-[#F9F9F9] w-[80%] p-4 rounded-lg ">
        <div className="flex items-center">
          <p className="text-[20px] font-bold">Tickets Raised</p>
          <p className="text-[14px] text-[#828282] ml-2">This week</p>
        </div>
        <div className="flex justify-between mt-2 config-col">
          <div className="bg-white w-[32%] p-2 px-4 rounded-lg super-admin-card-01">
            <div className="flex justify-between">
              <p className="text-[#D58D49] bg-[#dfa87446] text-[12px] py-1 px-2 rounded-lg font-bold">
                Low
              </p>
              <img
                src={threeHorizontalDots_icon}
                alt="three dots"
                className="object-contain w-4"
              />
            </div>
            <p className="text-[18px] font-bold mt-2">Brainstorming</p>
            <p className="text-[12px] text-[#787486] mt-2">
              Brainstorming brings team members' diverse experience into play.{" "}
            </p>

            <div className="flex justify-between mt-6">
              <img
                src={users_icon_02}
                alt="users"
                className="w-16 object-contain"
              />
              <div className="flex items-center text-[12px] text-[#787486]">
                <img
                  src={comments_icon}
                  alt="comments"
                  className="object-contain w-4 mr-1"
                />
                <p>12 comments</p>
              </div>
              <div className="flex items-center text-[12px] text-[#787486]">
                <img
                  src={files_icon}
                  alt="files"
                  className="object-contain w-4 mr-1"
                />
                <p>0 files</p>
              </div>
            </div>
          </div>
          {/* 2 */}
          <div className="bg-white w-[32%] p-2 px-4 rounded-lg super-admin-card-01">
            <div className="flex justify-between ">
              <p className="text-[#D8727D] bg-[#d8727c24] text-[12px] py-1 px-2 rounded-lg font-bold">
                High
              </p>
              <img
                src={threeHorizontalDots_icon}
                alt="three dots"
                className="object-contain w-4"
              />
            </div>
            <p className="text-[18px] font-bold mt-2">Research</p>
            <p className="text-[12px] text-[#787486] mt-2">
              User research helps you to create an optimal product for users.
            </p>

            <div className="flex justify-between mt-6">
              <img
                src={users_icon_02}
                alt="users"
                className="w-16 object-contain"
              />
              <div className="flex items-center text-[12px] text-[#787486]">
                <img
                  src={comments_icon}
                  alt="comments"
                  className="object-contain w-4 mr-1"
                />
                <p>12 comments</p>
              </div>
              <div className="flex items-center text-[12px] text-[#787486]">
                <img
                  src={files_icon}
                  alt="files"
                  className="object-contain w-4 mr-1"
                />
                <p>0 files</p>
              </div>
            </div>
          </div>
          {/* 3 */}
          <div className="bg-white w-[32%] p-2 px-4 rounded-lg super-admin-card-01">
            <div className="flex justify-between">
              <p className="text-[#D8727D] bg-[#d8727c24] text-[12px] py-1 px-2 rounded-lg font-bold">
                High
              </p>
              <img
                src={threeHorizontalDots_icon}
                alt="three dots"
                className="object-contain w-4"
              />
            </div>
            <p className="text-[18px] font-bold mt-2">Team Strategy</p>
            <p className="text-[12px] text-[#787486] mt-2">
              Team strategy encourages teamwork, breaking down silos for
              successful execution.
            </p>

            <div className="flex justify-between mt-6">
              <img
                src={users_icon_02}
                alt="users"
                className="w-16 object-contain"
              />
              <div className="flex items-center text-[12px] text-[#787486]">
                <img
                  src={comments_icon}
                  alt="comments"
                  className="object-contain w-4 mr-1"
                />
                <p>12 comments</p>
              </div>
              <div className="flex items-center text-[12px] text-[#787486]">
                <img
                  src={files_icon}
                  alt="files"
                  className="object-contain w-4 mr-1"
                />
                <p>0 files</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ml-4 mt-8 w-[80%]">
        <img
          src={appDetails_graph}
          alt="app details graph"
          className="w-full"
        />
      </div>

      <div className="ml-4 mt-8 bg-[#F9F9F9] rounded-lg w-[80%] p-4 my-8">
        <p className="text-[16px] font-bold">Client Details</p>
        <p className="text-[12px] mt-2">Client Interaction details</p>
        <div className="flex flex-col justify-start w-[100%] mt-4">
          <div className="flex w-full config-col">
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 ml-10 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 ml-10 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
          </div>
          <div className="flex w-full config-col">
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 ml-10 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 ml-10 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
          </div>
          <div className="flex w-full config-col">
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
            <div className="bg-white flex items-center p-3 w-[30%] rounded-lg mt-4 ml-10 super-admin-card-02">
              <img src={westside_image} alt="westside_image" className="w-6" />
              <p className="text-[14px] font-bold ml-2">Westside</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
